export const getBrand = (store) => {
  const { nonLeonardStore } = store;
  if (nonLeonardStore) {
    return "Cook";
  }

  return "Leonard";
};
